import request from "@/utils/request";
//登录
export function login(data) {
  return request({
    url: "/admin/login",
    method: "post",
    data,
  });
}

// 用户列表
export function userlist(params) {
  return request({
    url: "/admin/users/list",
    method: "get",
    params,
  });
}

// 用户详情
export function userinfo(params) {
  return request({
    url: "/admin/users/info",
    method: "get",
    params,
  });
}

// 修改用户
export function edituser(data) {
  return request({
    url: "/admin/users/edit",
    method: "put",
    data,
  });
}

// 修改密码
export function editpwd(data) {
  return request({
    url: "/admin/users/update/pass",
    method: "post",
    data,
  });
}

// 删除用户
export function deluser(params) {
  return request({
    url: "/admin/users/del",
    method: "delete",
    params,
  });
}

// 新增用户
export function adduser(data) {
  return request({
    url: "/admin/users/add",
    method: "post",
    data,
  });
}

// 设为管理员
export function setadmin(data) {
  return request({
    url: "/admin/users/set/admin/state",
    method: "post",
    data,
  });
}

// 获取rolelist
export function rolelist(params) {
  return request({
    url: "/admin/sysRole/data",
    method: "get",
    params,
  });
}


//切换语言
export function changeLanguages(lang){
  return request({
    url: '/admin/sysResource/menu',
    method: 'get',
    // headers: {
    //   isToken: false,
    // },
    params: {
      lang: lang
    }
  })
}